const ITEMS = [
  "ARTIST LOANS",
  "LABEL LINES OF CREDIT",
  "BUSINESS CREDIT CARDS",
  "CATALOG ADVANCES",
  "ZERO EQUITY SURRENDER",
  "100% RIGHTS RETAINED",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif text-2xl sm:text-3xl italic text-[#d4af37] px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="w-2 h-2 rotate-45 bg-[#d4af37] shrink-0" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-[#c9a227] bg-[#4D4232] py-6"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
